/* x-gift-box.js - Sallora "Pakowanie na prezent" (2026-09-04, r2)
   ---------------------------------------------------------------------------
   TWO logics, Lasha 2026-09-04:
     1. FREE: from 300 zl of jewellery in the cart, exactly ONE box is free.
        The price is zeroed by the automatic Buy-X-get-Y discount
        "Pudelko prezentowe gratis od 300 zl" (limit 1 per order). This script
        only auto-adds the box when the cart crosses 300 zl, and takes that
        one box away again if the cart drops back under (the customer can
        untick it; we then stop re-adding it for the session).
     2. PAID: the box is a normal cart line at 25,00 zl - the cart stepper
        works, buy as many as you like. Every box beyond the free one is paid.

   Surfaces: one checkbox on every product page (under .x-atc-row, never on
   the box's own page) and on the cart page (above #checkout-submit).
   The cart is the single source of truth, so both surfaces always agree.
   The theme's own "Dodaj do koszyka" form is never touched.
   2026-10-18: the CART checkbox hides while the only jewellery in the cart is
   a set (type "Zestaw" = a native bundle that already holds its own box).
   A set counts toward the 300 zl only together with another piece - a set
   alone never gets the free box (Lasha 2026-10-18). Collection `all` holds
   type Zestaw, so the discount counts the set's price too.
   Fuller version (2 colours + free printed card) is parked in
   `_work/giftbox/x-gift-box.FULL.js.parked`.
   ---------------------------------------------------------------------------*/
(function () {
  'use strict';

  var BOX_VARIANT = 65057987133789;   // product "Pudelko prezentowe"
  var FREE_CENTS  = 30000;            // 300 zl of NON-box lines, in grosze = the discount's threshold
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var EN   = (document.documentElement.lang || 'pl').toLowerCase().indexOf('en') === 0;

  var T = EN ? {
    title: 'Gift wrapping',
    price: '+ 25,00 zł',
    free: 'Gratis',
    desc: 'Sallora gift box — we pack your order ready to be given. One box free on orders from 300 zł.',
    added: 'Added to cart',
    working: 'One moment…',
    more: 'See the gift box',
    mixed: function (n) { return '1 × gratis + ' + n + ' × 25,00 zł'; }
  } : {
    title: 'Pakowanie na prezent',
    price: '+ 25,00 zł',
    free: 'Gratis',
    desc: 'Firmowe pudełko Sallora — pakujemy zamówienie gotowe do wręczenia. Przy zamówieniu od 300 zł jedno pudełko gratis.',
    added: 'Dodano do koszyka',
    working: 'Chwileczkę…',
    more: 'Zobacz pudełko',
    mixed: function (n) { return '1 × gratis + ' + n + ' × 25,00 zł'; }
  };

  var st = { box: false, qty: 0, key: null, free: false, busy: false, onlySets: false };

  // a set ("Zestaw") is one bundle line that already contains a gift box
  function isSet(it) { return it.product_type === 'Zestaw' || it.has_components === true; }

  // session flags: AUTO = the box in the cart was added by us at 300 zl;
  // OPTOUT = the customer unticked a free box, do not push it back this session.
  var K_AUTO = 'xgb-auto', K_OPTOUT = 'xgb-optout';
  function flag(k)      { try { return sessionStorage.getItem(k) === '1'; } catch (e) { return false; } }
  function setFlag(k, v){ try { if (v) sessionStorage.setItem(k, '1'); else sessionStorage.removeItem(k); } catch (e) {} }

  function cartStore() {
    return (window.Alpine && Alpine.store && Alpine.store('xCartHelper')) || null;
  }

  function getCart() {
    return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  // POST a cart mutation and let the theme re-render its own cart sections.
  function mutate(url, body) {
    var s = cartStore();
    body.sections = s ? s.getSectionsToRender().map(function (x) { return x.id; }) : [];
    body.sections_url = window.location.pathname;
    return fetch(ROOT + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (s && res && res.sections) {
          s.reRenderSections(res.sections);
          var bubble = document.querySelector('#cart-icon-bubble span');
          if (bubble) {
            var n = parseInt(bubble.innerHTML, 10);
            if (!isNaN(n)) s.currentItemCount = n;
          }
        }
        return res;
      });
  }

  // Read the cart, then apply the FREE logic:
  //   crosses 300 zl and no box  -> add one (unless the customer opted out)
  //   drops under 300 zl         -> take away the one WE added (paid extras stay)
  function readCart() {
    return getCart().then(function (cart) {
      var line = null, cents = 0, sets = 0, others = 0;
      (cart.items || []).forEach(function (it) {
        if (it.variant_id === BOX_VARIANT) { line = it; return; }
        cents += (it.final_line_price != null ? it.final_line_price : it.line_price) || 0;
        if (isSet(it)) sets++; else others++;
      });
      st.onlySets = sets > 0 && others === 0;
      st.box  = !!line;
      st.qty  = line ? line.quantity : 0;
      st.key  = line ? line.key : null;
      st.free = cents >= FREE_CENTS && others > 0;

      if (st.busy) return cart;
      if (st.free && !line && !flag(K_OPTOUT)) {
        setFlag(K_AUTO, true);
        st.busy = true; paint();
        return mutate('cart/add.js', { items: [{ id: BOX_VARIANT, quantity: 1 }] })
          .catch(function () {})
          .then(function () { st.busy = false; return readCart(); });
      }
      if (!st.free && line && flag(K_AUTO)) {
        setFlag(K_AUTO, false);
        st.busy = true; paint();
        return mutate('cart/change.js', { id: line.key, quantity: line.quantity - 1 })
          .catch(function () {})
          .then(function () { st.busy = false; return readCart(); });
      }
      if (line && !st.free) setFlag(K_AUTO, false);
      return cart;
    });
  }

  // The customer ticks the box: a normal add. If it is free, they took it
  // back after an opt-out - clear the flag.
  function addBox() {
    setFlag(K_OPTOUT, false);
    setFlag(K_AUTO, false);
    st.busy = true; paint();
    return mutate('cart/add.js', { items: [{ id: BOX_VARIANT, quantity: 1 }] })
      .catch(function () {})
      .then(function () { st.busy = false; flash(T.added); return readCart(); })
      .then(paint, paint);
  }

  // The customer unticks: every box goes (also the paid extras - unticked = no box).
  // If it was free, remember the opt-out so we do not push it straight back.
  function removeBox() {
    if (!st.key) { st.box = false; paint(); return Promise.resolve(); }
    if (st.free) setFlag(K_OPTOUT, true);
    setFlag(K_AUTO, false);
    st.busy = true; paint();
    return mutate('cart/change.js', { id: st.key, quantity: 0 })
      .catch(function () {})
      .then(function () { st.busy = false; return readCart(); })
      .then(paint, paint);
  }

  var flashText = '', flashTimer = null;
  function flash(txt) {
    flashText = txt;
    clearTimeout(flashTimer);
    flashTimer = setTimeout(function () { flashText = ''; paint(); }, 2200);
  }

  // A .js asset cannot run Liquid, so it cannot call `| asset_url`. Read OUR OWN
  // <script src> instead - every theme asset is a sibling of it - and swap the
  // filename. No CDN path is ever guessed or hardcoded.
  var ASSET_BASE = (function () {
    var s = document.currentScript;
    if (!s || !s.src) s = document.querySelector('script[src*="x-gift-box.js"]');
    if (!s || !s.src) return '';
    return s.src.split('?')[0].replace(/x-gift-box\.js$/, '');
  })();
  var PHOTO   = ASSET_BASE ? ASSET_BASE + 'x-giftbox-photo.jpg' : '';
  var BOX_URL = ROOT + 'products/pudelko-prezentowe';   // verified live, HTTP 200

  // The box must never offer itself its own gift box.
  var ON_BOX_PAGE = /\/products\/pudelko-prezentowe(?:[\/?#]|$)/.test(window.location.pathname);

  function css() {
    if (document.getElementById('x-giftbox-css')) return;
    var s = document.createElement('style');
    s.id = 'x-giftbox-css';
    s.textContent = [
      '.xgb{border-top:1px solid #e3e0da;border-bottom:1px solid #e3e0da;margin:0 0 16px;padding:14px 2px;',
        'font-family:"DM Sans",sans-serif;font-weight:300;color:#222;cursor:pointer;user-select:none}',
      '.xgb *{box-sizing:border-box}',
      '.xgb-head{display:flex;align-items:flex-start;gap:11px}',
      '.xgb-cb{flex:0 0 auto;width:16px;height:16px;border:1px solid #9a958c;background:#fff;margin-top:1px;',
        'display:inline-flex;align-items:center;justify-content:center;transition:background .15s,border-color .15s}',
      '.xgb-cb svg{width:10px;height:10px;stroke:#FCFAF7;stroke-width:2.4;fill:none;stroke-linecap:round;stroke-linejoin:round;opacity:0}',
      '.xgb.on .xgb-cb{background:#1D1D1D;border-color:#1D1D1D}',
      '.xgb.on .xgb-cb svg{opacity:1}',
      '.xgb-txt{flex:1 1 auto;min-width:0}',
      '.xgb-lbl{display:flex;align-items:baseline;justify-content:space-between;gap:10px}',
      '.xgb-lbl b{font-size:11.5px;letter-spacing:.6px;text-transform:uppercase;font-weight:500;color:#222}',
      '.xgb-price{font-size:11.5px;letter-spacing:.4px;color:#222;white-space:nowrap;font-weight:400}',
      '.xgb.free .xgb-price{color:#5f7a53;font-weight:500;letter-spacing:.6px;text-transform:uppercase}',
      '.xgb-desc{font-size:12px;line-height:1.45;color:#666;margin-top:5px;display:block}',
      '.xgb-thumb{display:none;margin:12px 0 0 27px}',
      '.xgb.on .xgb-thumb{display:block}',
      '.xgb-photo{width:78px;height:78px;object-fit:cover;display:block;background:#e8e3dc;',
        'border:1px solid #e3e0da;cursor:pointer;transition:border-color .15s,opacity .15s}',
      '.xgb-photo:hover{border-color:#1D1D1D;opacity:.88}',
      '.xgb-state{font-size:11px;color:#8a9d7e;letter-spacing:.3px;margin-top:8px;min-height:14px}',
      '.xgb.busy{opacity:.6;pointer-events:none}'
    ].join('');
    document.head.appendChild(s);
  }

  var CHECK = '<svg viewBox="0 0 24 24"><path d="M4 12.5l5.5 5.5L20 7"/></svg>';

  function makeNode(where) {
    var d = document.createElement('div');
    d.className = 'xgb';
    d.setAttribute('data-xgb', where);
    d.innerHTML =
      '<div class="xgb-head">' +
        '<span class="xgb-cb">' + CHECK + '</span>' +
        '<span class="xgb-txt">' +
          '<span class="xgb-lbl"><b>' + T.title + '</b><span class="xgb-price" data-xgb-price>' + T.price + '</span></span>' +
          '<span class="xgb-desc">' + T.desc + '</span>' +
        '</span>' +
      '</div>' +
      (PHOTO ? '<span class="xgb-thumb"><a href="' + BOX_URL + '" data-xgb-link title="' + T.more + '">' +
                 '<img class="xgb-photo" src="' + PHOTO + '" alt="' + T.title + '" loading="lazy">' +
               '</a></span>' : '') +
      '<div class="xgb-state" data-xgb-state></div>';
    var link = d.querySelector('[data-xgb-link]');
    if (link) link.addEventListener('click', function (e) { e.stopPropagation(); });
    d.addEventListener('click', function () {
      if (st.busy) return;
      if (st.box) removeBox(); else addBox();
    });
    return d;
  }

  function mount() {
    css();
    // product page: right under the add-to-cart row (never on the box's own page)
    var atc = ON_BOX_PAGE ? null : document.querySelector('.x-atc-row');
    if (atc && !atc.parentNode.querySelector('[data-xgb]')) {
      atc.parentNode.insertBefore(makeNode('pdp'), atc.nextSibling);
    }
    // cart page: just above the checkout button (the drawer has none by design)
    var co = document.getElementById('checkout-submit');
    if (co && !co.parentNode.querySelector('[data-xgb]')) {
      co.parentNode.insertBefore(makeNode('cart'), co);
    }
    paint();
  }

  function paint() {
    var stateTxt = st.busy ? T.working
                 : (st.box && st.free && st.qty > 1) ? T.mixed(st.qty - 1)
                 : flashText;
    Array.prototype.forEach.call(document.querySelectorAll('[data-xgb]'), function (root) {
      root.classList.toggle('on', st.box);
      root.classList.toggle('free', st.free);
      root.classList.toggle('busy', st.busy);
      root.style.display = (root.getAttribute('data-xgb') === 'cart' && st.onlySets && !st.box) ? 'none' : '';
      root.querySelector('[data-xgb-price]').textContent = st.free ? T.free : T.price;
      root.querySelector('[data-xgb-state]').textContent = stateTxt;
    });
  }

  // The theme replaces whole cart sections; re-mount whenever that happens.
  document.addEventListener('eurus:cart:items-changed', function () {
    setTimeout(function () { readCart().then(mount); }, 120);
  });

  var _fetch = window.fetch;
  if (typeof _fetch === 'function') {
    window.fetch = function (input) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      try {
        if (!st.busy && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
          p.then(function () { setTimeout(function () { readCart().then(mount); }, 120); }, function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  function boot() { readCart().then(mount).catch(mount); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 300); });
  } else {
    setTimeout(boot, 300);
  }
})();
